export const replaceBackSlashesWithSlashes = (string) => string.replace(/\\/g, "/")
